// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"81202eda","81":"65a1f13b","109":"bcc05284","141":"958d26ae","222":"76ad1860","247":"24fbb1e0","354":"dd6ad5af","386":"165699b8","454":"aaff3dbf","496":"a0253813","588":"79ffd047","691":"2817f6f1","737":"99a15e18","792":"f253a4a5"}[chunkId] + ".chunk.js";
};